'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _lurker = require('../../../util/lurker');
var _staticUrl = require('../../../config/staticUrl');
var _abTests = require('../../../config/abTests');
var _style = require('./style');
var _MenuItem = require('./MenuItem');
var _MenuItem2 = _interopRequireDefault(_MenuItem);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SubMenu = function (_React$PureComponent) {
  (0, _inherits3.default)(SubMenu, _React$PureComponent);
  function SubMenu(props) {
    (0, _classCallCheck3.default)(this, SubMenu);
    var _this = (0, _possibleConstructorReturn3.default)(this, (SubMenu.__proto__ || (0, _getPrototypeOf2.default)(SubMenu)).call(this, props));
    _this.state = {
      urls: {}
    };
    return _this;
  }
  (0, _createClass3.default)(SubMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        urls: (0, _extends3.default)({}, (0, _staticUrl.getUrls)())
      });
    }
  }, {
    key: 'renderAccountLink',
    value: function renderAccountLink() {
      var _props = this.props,
        isLogged = _props.isLogged,
        isDropDown = _props.isDropDown,
        userName = _props.userName,
        profilePictureUrl = _props.profilePictureUrl;
      if (isLogged === true) {
        if (!isDropDown) {
          return _react2.default.createElement(_style.UserLinkMenuStyled, {
            href: _staticUrl.minhaConta,
            userName: userName,
            profilePictureUrl: profilePictureUrl
          });
        }
        return _react2.default.createElement(_MenuItem2.default, {
          href: _staticUrl.minhaConta,
          isDropDown: isDropDown,
          iconName: 'User',
          label: 'Meu cadastro'
        });
      }
      if (isLogged === false) {
        return _react2.default.createElement(_MenuItem2.default, {
          href: _staticUrl.login,
          isDropDown: isDropDown,
          iconName: 'LogIn',
          label: 'Entrar'
        });
      }
      return _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.minhaConta,
        isDropDown: isDropDown,
        iconName: 'User',
        label: 'Minha Conta'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
        isLogged = _props2.isLogged,
        isDropDown = _props2.isDropDown,
        notifications = _props2.notifications,
        userProfileLink = _props2.userProfileLink,
        showMyPlanButton = _props2.showMyPlanButton;
      var _state$urls = this.state.urls,
        chat = _state$urls.chat,
        meusAnuncios = _state$urls.meusAnuncios;
      var professionalPlanLink = _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.meuPlano,
        onClick: function onClick() {
          return (0, _lurker.lurkerClickEvent)('myplan', 'navbar');
        },
        isDropDown: isDropDown,
        iconName: 'Briefcase',
        label: 'Plano profissional'
      });
      var searchLink = _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.busca,
        onClick: function onClick() {
          return (0, _lurker.lurkerClickEvt)('header_buscar');
        },
        isDropDown: isDropDown,
        iconName: 'Search',
        label: 'Buscar'
      });
      var chatLink = _react2.default.createElement(_MenuItem2.default, {
        href: chat,
        isDropDown: isDropDown,
        iconName: 'MessageCircle',
        label: 'Chat'
      });
      var myAdsLink = _react2.default.createElement(_MenuItem2.default, {
        href: meusAnuncios,
        isDropDown: isDropDown,
        iconName: 'Grid',
        label: 'Meus an\xFAncios'
      });
      var mySalesOlxPayLink = _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.vendasOLXPay,
        onClick: function onClick() {
          return (0, _lurker.lurkerClickEvent)('my_sales_olx_pay', 'menu');
        },
        isDropDown: isDropDown,
        iconName: 'Shop',
        label: 'Vendas OLX Pay',
        badgeLabel: (0, _abTests.isOrdersMenuNewLabelEnabled)() && 'NOVO'
      });
      var myPurchasesOlxPayLink = _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.comprasOLXPay,
        onClick: function onClick() {
          return (0, _lurker.lurkerClickEvent)('my_purchases_olx_pay', 'menu');
        },
        isDropDown: isDropDown,
        iconName: 'ShoppingBag',
        label: 'Compras OLX Pay',
        badgeLabel: (0, _abTests.isOrdersMenuNewLabelEnabled)() && 'NOVO'
      });
      return _react2.default.createElement(_style.Nav, this.props, _react2.default.createElement(_style.Ul, null, _react2.default.createElement(_style.Li, null, this.renderAccountLink()), !isLogged ? _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_style.Li, null, searchLink), _react2.default.createElement(_style.Divider, {
        withHorizontalMargins: isDropDown
      }), _react2.default.createElement(_style.Li, null, myAdsLink), _react2.default.createElement(_style.Li, null, chatLink), showMyPlanButton && _react2.default.createElement(_style.Li, null, professionalPlanLink), (0, _abTests.isOrdersMenuEnabled)() && _react2.default.createElement(_style.Li, null, mySalesOlxPayLink), (0, _abTests.isOrdersMenuEnabled)() && _react2.default.createElement(_style.Li, null, myPurchasesOlxPayLink)) : _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_style.Divider, {
        withHorizontalMargins: isDropDown
      }), !isDropDown && _react2.default.createElement(_style.Li, null, searchLink), !isDropDown && _react2.default.createElement(_style.Divider, null), _react2.default.createElement(_style.Li, null, chatLink), _react2.default.createElement(_style.Divider, {
        withHorizontalMargins: isDropDown
      }), _react2.default.createElement(_style.Li, null, myAdsLink), (0, _abTests.isOrdersMenuEnabled)() && _react2.default.createElement(_style.Li, null, mySalesOlxPayLink), _react2.default.createElement(_style.Li, null, _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.olxPay,
        isDropDown: isDropDown,
        onClick: function onClick() {
          return (0, _lurker.lurkerClickEvt)('header_olx_pay');
        },
        iconName: 'Wallet',
        label: 'Conta OLX Pay'
      })), _react2.default.createElement(_style.Li, null, professionalPlanLink), _react2.default.createElement(_style.Li, null, _react2.default.createElement(_MenuItem2.default, {
        href: userProfileLink,
        isDropDown: isDropDown,
        iconName: 'Share2',
        label: 'Meu perfil p\xFAblico'
      })), _react2.default.createElement(_style.Divider, {
        withHorizontalMargins: isDropDown
      }), (0, _abTests.isOrdersMenuEnabled)() && _react2.default.createElement(_style.Li, null, myPurchasesOlxPayLink), _react2.default.createElement(_style.Li, null, _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.favoritos,
        isDropDown: isDropDown,
        onClick: function onClick() {
          return (0, _lurker.lurkerClickEvt)('header_favoritos');
        },
        iconName: 'Heart',
        label: 'Favoritos'
      })), _react2.default.createElement(_style.Divider, {
        withHorizontalMargins: isDropDown
      }), _react2.default.createElement(_style.Li, null, _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.centralDeSeguranca,
        isDropDown: isDropDown,
        onClick: function onClick() {
          return (0, _lurker.lurkerClickEvt)('header_security_central');
        },
        iconName: 'Shield',
        label: 'Seguran\xE7a e privacidade'
      })), _react2.default.createElement(_style.Li, null, _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.gerenciarComunicacoes,
        isDropDown: isDropDown,
        onClick: function onClick() {
          return (0, _lurker.lurkerClickEvt)('header_comunicacoes');
        },
        iconName: 'Sliders',
        label: 'Configura\xE7\xE3o de comunica\xE7\xF5es'
      })), _react2.default.createElement(_style.Li, null, _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.gerenciarPagamentos,
        isDropDown: isDropDown,
        onClick: function onClick() {
          return (0, _lurker.lurkerClickEvt)('header_pagamentos');
        },
        iconName: 'Money',
        label: 'Gerenciar Pagamentos'
      })), _react2.default.createElement(_style.Li, {
        hasBadge: notifications > 0,
        'data-counter': notifications > 99 ? '99+' : notifications
      }, _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.notificacoes,
        isDropDown: isDropDown,
        onClick: function onClick() {
          return (0, _lurker.lurkerClickEvt)('header_notificacoes', {
            data: {
              has_badge: notifications > 0 ? 'true' : 'false'
            }
          });
        },
        iconName: 'Bell',
        label: 'Notifica\xE7\xF5es'
      })), _react2.default.createElement(_style.Divider, {
        withHorizontalMargins: isDropDown
      }), _react2.default.createElement(_style.Li, null, _react2.default.createElement(_MenuItem2.default, {
        href: _staticUrl.sair,
        isDropDown: isDropDown,
        iconName: 'LogOut',
        label: 'Sair'
      })))));
    }
  }]);
  return SubMenu;
}(_react2.default.PureComponent);
SubMenu.defaultProps = {
  isOpen: true,
  isDropDown: false,
  notifications: 0,
  showMyPlanButton: false
};
SubMenu.propTypes = {
  isOpen: _propTypes2.default.bool,
  isDropDown: _propTypes2.default.bool,
  isLogged: _propTypes2.default.bool,
  userName: _propTypes2.default.string,
  profilePictureUrl: _propTypes2.default.string,
  userProfileLink: _propTypes2.default.string,
  notifications: _propTypes2.default.number,
  showMyPlanButton: _propTypes2.default.bool
};
exports.default = SubMenu;